import { exists } from '@/api'

export interface BatchDataShortageUserListCondition {
  userRegistrationDateFrom: string
  userRegistrationDateTo: string
  userRegistrationBranchCode: string
  order: string
  userType: string
  checkShortageItems: []
}

export function BatchDataShortageUserListConditionFromJSON(
  json: any
): BatchDataShortageUserListCondition {
  const _json = JSON.parse(json)

  return {
    userRegistrationDateFrom: exists(_json, 'user_registration_date_from')
      ? _json.user_registration_date_from
      : '',
    userRegistrationDateTo: exists(_json, 'user_registration_date_to')
      ? _json.user_registration_date_to
      : '',
    userRegistrationBranchCode: exists(_json, 'user_registration_branch_code')
      ? _json.user_registration_branch_code
      : '',
    order: exists(_json, 'order') ? _json.order : '1',
    userType: exists(_json, 'user_type') ? _json.user_type : '1',
    checkShortageItems: exists(_json, 'check_shortage_items')
      ? _json.check_shortage_items
      : []
  }
}
